export default {
  labelHidden: 'Label Hidden',
  streetMap: 'Street map',
  imageMap: 'Imaging image',
  open: 'Open',
  putitaway: 'Hide',
  deviceTotal: 'Total number of devices',
  deviceRun: 'Device operation',
  deviceStop: 'Device shutdown',
  deviceFault: 'Device failure',
  deviceOffline: 'Device offline'
}
